import intlTelInput from 'intl-tel-input';
import intlTelInputUtils from 'intl-tel-input/build/js/utils';

export function init_phone(selector = ''){
    const el_id = selector ? selector : 'phone';
    let account_phone = document.querySelector("#" + el_id);
    if (account_phone !== null) {
        let iti = intlTelInput(account_phone, {
            initialCountry: "auto",
            separateDialCode: true,
            hiddenInput: 'phone_full',
            utilsScript: intlTelInputUtils,
            geoIpLookup: function(callback) {
                $.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
                    const countryCode = (resp && resp.country) ? resp.country : "";
                    callback(countryCode);
                });
            },
        });
        ['change', 'input', 'countrychange'].forEach(function(e) {
            account_phone.addEventListener(e, function() {
                let d = iti.getSelectedCountryData();
                if (d.dialCode !== undefined){
                    $('#dialCode').val(d.dialCode);
                }
            });
        });
    }
}